import type { CityConfig } from "../city-template/types";

export const georgetownConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Georgetown",
  state: "Kentucky",
  stateAbbr: "KY",
  slug: "georgetown",
  route: "/georgetown",
  title: "Emergency Passport Georgetown, KY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Georgetown, KY — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Scott County, Toyota Manufacturing employees, and Georgetown College students. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Georgetown, KY",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Georgetown and Scott County travelers get their expedited passports as quickly as 24 hours. Serving Toyota Manufacturing employees, Georgetown College students, and the growing suburban Lexington community. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Georgetown%20Kentucky%20charming%20small%20town%20downtown%20with%20historic%20Main%20Street%20buildings%2C%20Scott%20County%20courthouse%20with%20red%20brick%20architecture%2C%20Toyota%20manufacturing%20plant%20visible%20in%20distance%2C%20suburban%20neighborhoods%20with%20trees%2C%20warm%20afternoon%20sunlight%2C%20clean%20cityscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20panoramic%20view%20of%20growing%20Kentucky%20town%20with%20rolling%20hills%20background%2C%20wide%20landscape%20view&width=1800&height=700&seq=georgetown-hero-001&orientation=landscape",
  heroImageAlt: "Georgetown Kentucky historic downtown with Scott County courthouse and Toyota manufacturing at golden hour",
  geoPosition: "38.2098;-84.5588",
  geoPlacename: "Georgetown, Kentucky",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "77 W Jackson Blvd, Suite 1200, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 370 miles from Georgetown via I-75 and I-90",
  },
  nearbyCitiesZips: [
    { name: "Georgetown", zips: "40324" },
    { name: "Lexington", zips: "40502, 40503, 40504, 40505, 40506, 40507, 40508, 40509, 40510, 40511, 40513, 40514, 40515, 40516, 40517, 40526, 40533, 40536, 40544, 40546, 40550, 40555, 40574, 40575, 40576, 40577, 40578, 40579, 40580, 40581, 40582, 40583, 40588, 40591, 40598" },
    { name: "Frankfort", zips: "40601, 40602, 40603, 40604, 40618, 40619, 40620, 40621, 40622" },
    { name: "Paris", zips: "40361, 40362" },
    { name: "Versailles", zips: "40383, 40384, 40385, 40386" },
    { name: "Nicholasville", zips: "40356, 40340" },
    { name: "Winchester", zips: "40391, 40392" },
    { name: "Richmond", zips: "40475, 40476" },
    { name: "Harrodsburg", zips: "40330" },
    { name: "Lawrenceburg", zips: "40342" },
    { name: "Midway", zips: "40347" },
    { name: "Stamping Ground", zips: "40379" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Scott County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Lexington", route: "/lexington" },
    { name: "Fast passport renewal in Frankfort", route: "/frankfort" },
    { name: "Emergency passport help in Louisville", route: "/louisville" },
    { name: "Urgent passport services in Danville", route: "/danville" },
    { name: "Same-day passport help in Paris", route: "/paris" },
    { name: "Passport courier services near Winchester", route: "/winchester" },
  ],
  fpcOfficeAddress: "500 W Jefferson St, Suite 2100, Louisville, KY 40202",
  fpcOfficeNote: "Fast Passport Center serves Georgetown remotely via secure courier. We do not have a walk-in office in Georgetown — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Scott County travelers.",
  fpcOfficeDistance: "Serving all of Scott County and the Lexington-Greater Area",
  serviceAreaIntro: "From the historic Georgetown downtown to the Toyota manufacturing campus, from Georgetown College to the growing suburban developments — Fast Passport Center serves the entire Georgetown community and surrounding Lexington metro area. We regularly help travelers from Paris, Versailles, and Frankfort get their passports fast.",
  nearbyCitiesIntro: "We serve all Georgetown neighborhoods and nearby Scott County cities including Lexington, Frankfort, Paris, Versailles, Nicholasville, Winchester, Richmond, Harrodsburg, Lawrenceburg, Midway, and Stamping Ground. If you are in Scott County, the Lexington metro area, or central Kentucky, we have you covered.",
  howItWorksIntro: "Most Georgetown travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Georgetown travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Georgetown and Scott County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Georgetown? Here are the most common ones we hear from Scott County travelers.",
  statePageRoute: "/states/kentucky",
  statePageName: "Kentucky",
  dmvWebsite: "https://drive.ky.gov",
  dmvLabel: "Kentucky Transportation Cabinet — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Scott County international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "James W.",
      location: "Georgetown, KY",
      rating: 5,
      text: "I'm an engineer at Toyota and had a business trip to Japan with only 5 days notice. My passport was expired. Fast Passport Center renewed it in 48 hours. They understood corporate travel urgency and made it seamless.",
      service: "Passport Renewal",
    },
    {
      name: "Samantha D.",
      location: "Georgetown, KY",
      rating: 5,
      text: "My daughter at Georgetown College needed a passport for a semester abroad in Italy. Fast Passport Center walked us through the new passport process and got it done in 4 days. Perfect for college students with tight deadlines.",
      service: "New Passport",
    },
    {
      name: "Patricia N.",
      location: "Paris, KY",
      rating: 5,
      text: "We planned a family reunion in Ireland and I realized my passport had expired three weeks before. Fast Passport Center got my renewal done in 3 days. Saved our trip to visit relatives in Dublin.",
      service: "Passport Renewal",
    },
    {
      name: "Michael T.",
      location: "Versailles, KY",
      rating: 5,
      text: "Had an emergency requiring travel to Canada within 48 hours. Fast Passport Center processed my emergency passport in 24 hours. Their speed was absolutely critical when every minute counted.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "georgetown-1",
      name: "Georgetown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 S Hamilton St",
      city: "Georgetown",
      state: "KY",
      zip: "40324",
      phone: "(502) 863-1161",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Georgetown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Scott County. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "georgetown-2",
      name: "Scott County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "119 N Hamilton St",
      city: "Georgetown",
      state: "KY",
      zip: "40324",
      phone: "(502) 863-7979",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from Georgetown Courthouse",
      website: "https://www.scottcountyky.gov/",
      websiteLabel: "Scott County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "georgetown-3",
      name: "Lexington Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "760 N Broadway",
      city: "Lexington",
      state: "KY",
      zip: "40508",
      phone: "(859) 252-1522",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles from Georgetown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Georgetown residents near Lexington. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "georgetown-4",
      name: "Paris Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "222 W 8th St",
      city: "Paris",
      state: "KY",
      zip: "40361",
      phone: "(859) 987-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Paris",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bourbon County. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "georgetown-5",
      name: "Frankfort Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1217 US-127 S",
      city: "Frankfort",
      state: "KY",
      zip: "40601",
      phone: "(502) 227-1551",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "18 miles from Georgetown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Georgetown residents near the state capital. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "georgetown-6",
      name: "Winchester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 N Main St",
      city: "Winchester",
      state: "KY",
      zip: "40391",
      phone: "(859) 744-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles from Georgetown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Clark County residents. Convenient for Winchester area.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Georgetown area photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Scott County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Georgetown applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Scott County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Lexington metro area travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Georgetown." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Georgetown address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Georgetown before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Georgetown for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Georgetown?", a: "Fast Passport Center offers fast passport renewal in Georgetown in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. Many cruise lines require your passport to be valid for at least 6 months beyond your travel date. We can expedite your passport renewal in Georgetown in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Georgetown?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 6 hour drive from Georgetown — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Scott County residents." },
    { q: "Can I expedite a child passport in Georgetown?", a: "Yes. Fast Passport Center expedites child passports in Georgetown for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Scott County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Georgetown with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Georgetown?", a: "With Fast Passport Center's emergency courier service, Georgetown travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Georgetown?", a: "Popular options include the Georgetown Post Office (40324), Scott County Clerk (40324), Lexington Main Post Office (40508), Paris Post Office (40361), Frankfort Main Post Office (40601), and Winchester Post Office (40391). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Georgetown?", a: "Same-day passports are only available at the Chicago Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 6 hour drive to Chicago." },
    { q: "What if I live in a smaller Scott County town?", a: "We serve the entire Lexington metro area including Paris, Versailles, Frankfort, Nicholasville, Winchester, Richmond, Harrodsburg, Lawrenceburg, Midway, and Stamping Ground. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Georgetown?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Georgetown?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Georgetown offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Georgetown?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Georgetown?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Scott County families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Georgetown", address: "1017 Cherry Blossom Way, Georgetown, KY 40324", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Georgetown", address: "1000 Lemons Mill Rd, Georgetown, KY 40324", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart — Georgetown", address: "1120 Paris Pike, Georgetown, KY 40324", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Rite Aid — Georgetown", address: "1025 Lexington Rd, Georgetown, KY 40324", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "CVS Pharmacy — Paris", address: "301 Letton Dr, Paris, KY 40361", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Versailles", address: "525 Marsailles Rd, Versailles, KY 40383", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Frankfort", address: "1305 US-127 S, Frankfort, KY 40601", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Georgetown", address: "110 S Hamilton St, Georgetown, KY 40324", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "Circuit Court Clerk — Scott County",
      address: "119 N Hamilton St, Georgetown, KY 40324",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Driver's license and REAL ID. Appointment recommended.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Franklin County",
      address: "315 W Main St, Frankfort, KY 40601",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID and driver's license renewals. Online booking available.",
      featured: false,
    },
    {
      name: "Circuit Court Clerk — Fayette County",
      address: "162 E Main St, Lexington, KY 40507",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service center for Lexington area residents.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Bourbon County",
      address: "310 E Main St, Paris, KY 40361",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Alternative for Bourbon County residents. Walk-ins limited.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LEX",
      name: "Blue Grass Airport (Lexington)",
      distance: "12 miles from Georgetown",
      address: "4000 Terminal Dr, Lexington, KY 40510",
      note: "The closest major airport for Scott County travelers. Domestic flights with connections to major international hubs.",
      flightUrl: "https://www.bluegrassairport.com/",
      flightLabel: "Blue Grass Airport",
      featured: true,
    },
    {
      code: "SDF",
      name: "Louisville Muhammad Ali International",
      distance: "70 miles from Georgetown",
      address: "600 Terminal Dr, Louisville, KY 40209",
      note: "Alternative regional airport with flights to major hubs.",
      flightUrl: "https://www.flylouisville.com/",
      flightLabel: "Louisville Airport",
      featured: false,
    },
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International",
      distance: "90 miles from Georgetown",
      address: "3087 Terminal Dr, Hebron, KY 41048",
      note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-75.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Birth & Death Certificates", desc: "Kentucky Office of Vital Statistics in Frankfort — order certified copies online, by mail, or in person for passport applications and name changes.", url: "https://www.chfs.ky.gov/agencies/dph/dehp/vsb/Pages/default.aspx" },
    { icon: "ri-heart-line", label: "Marriage Records", desc: "Scott County Clerk — certified marriage licenses for name change passport applications and legal documentation.", url: "https://www.scottcountyky.gov/" },
    { icon: "ri-scales-line", label: "Divorce Decrees", desc: "Scott Circuit Court Clerk — certified divorce decrees supporting passport name change or correction.", url: "https://kycourts.gov/Courts/Circuit-Court/Pages/Scott.aspx" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Kentucky, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};